/**
 * Het Archief (§15) — doorklikbare kennisbank: 9 scrollen, elk een Gids-monoloog.
 * Los van de gevechten; altijd bereikbaar.
 */
import { useState } from 'react';
import { ARCHIEF } from '../data/archive';
import { archiefTitel, archiefMonoloog } from '../data/content';
import { GidsTekst } from './GidsTekst';
import { t, type Taal } from '../i18n';

interface Props {
  taal: Taal;
  onTerug: () => void;
}

const GOUD = '#c9a86a';

export function Archief({ taal, onTerug }: Props) {
  const [open, setOpen] = useState<number | null>(null);

  if (open !== null) {
    const scroll = ARCHIEF[open];
    return (
      <div className="mandala-textuur flex h-full w-full flex-col bg-achtergrond text-slate-100">
        <div className="flex items-center justify-between border-b border-white/10 px-4 py-2">
          <h2 className="text-lg font-bold" style={{ fontFamily: 'Cinzel, serif', color: GOUD }}>{archiefTitel(scroll.id, scroll.titel, taal)}</h2>
          <button type="button" onClick={() => setOpen(null)} className="rounded border border-white/15 px-3 py-1 text-sm hover:bg-white/5">← {t('ui.terug', taal)}</button>
        </div>
        <div className="flex flex-1 items-center justify-center overflow-y-auto p-6">
          <div className="flex flex-col items-center gap-6">
            <div className="h-16 w-16 rounded-full blur-[3px]" style={{ background: `radial-gradient(circle at 45% 40%, #f5edd6, ${GOUD} 60%, transparent 78%)` }} />
            <GidsTekst tekst={archiefMonoloog(scroll.id, scroll.monoloog, taal)} kleur={GOUD} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mandala-textuur flex h-full w-full flex-col bg-achtergrond text-slate-100">
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-2">
        <h2 className="text-lg font-bold" style={{ fontFamily: 'Cinzel, serif', color: GOUD }}>{t('ui.archief', taal)}</h2>
        <button type="button" onClick={onTerug} className="rounded border border-white/15 px-3 py-1 text-sm hover:bg-white/5">← {t('ui.terug', taal)}</button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <ul className="mx-auto grid max-w-2xl grid-cols-1 gap-2 sm:grid-cols-2">
          {ARCHIEF.map((s, i) => (
            <li key={s.id}>
              <button
                type="button"
                onClick={() => setOpen(i)}
                className="flex w-full items-center gap-3 rounded-xl border border-white/10 p-3 text-left transition hover:-translate-y-0.5 hover:border-white/25"
                style={{ background: 'linear-gradient(120deg, #14121c, #1b1726)' }}
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm" style={{ background: `${GOUD}22`, color: GOUD, fontFamily: 'JetBrains Mono, monospace' }}>{i + 1}</span>
                <span className="text-sm font-semibold" style={{ color: '#ece6da', fontFamily: 'Cinzel, serif' }}>{archiefTitel(s.id, s.titel, taal)}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
